import React from 'react';
import { WhiteArrow, BlackArrow } from './arrows';
import { WhiteIndicator, BlackIndicator, useMaxIndicatorSizeValue } from './indicators';
import { CircleBackground, CircleProgress, CircleText } from './circles';
import './percentage-circle.scss';

const useCircleDimensions = (size, strokeWidth, whiteIndicator, blackIndicator) => { 
  const maxIndicatorSize = useMaxIndicatorSizeValue(whiteIndicator, blackIndicator);
  const indicatorOffset = whiteIndicator || blackIndicator ? maxIndicatorSize * 2 - strokeWidth / 2 : 0;
  
  const radius = (size - strokeWidth - indicatorOffset) / 2;
  const circumference = 2 * Math.PI * radius;
  const center = size / 2;
  
  return {
    radius, circumference, center
  }
}

const PercentageCircle = ({
  value,
  size = 120,
  strokeWidth = 10,
  color = '#808285',
  bgColor = '#DADBDC',
  textColor = '#353535',
  dotColor = '#353535',
  whiteIndicator,
  blackIndicator,
}) => {
  
  const dimensions = useCircleDimensions(size, strokeWidth, whiteIndicator, blackIndicator);
  return (
    <div className="percentage-circle">
      <svg width={size} height={size}>
        <CircleBackground {...dimensions} bgColor={bgColor} strokeWidth={strokeWidth} />
        <CircleProgress dimensions={dimensions} value={value} color={color} dotColor={dotColor} strokeWidth={strokeWidth} />
        {blackIndicator && <BlackIndicator dotColor={dotColor} color={color} dimensions={dimensions} indicator={blackIndicator} />}
        {whiteIndicator && <WhiteIndicator color={color} dimensions={dimensions} indicator={whiteIndicator} />}
        <CircleText radius={dimensions.radius} value={value} textColor={textColor} />
      </svg>  
      {whiteIndicator &&
        <Legend size={whiteIndicator.legendSize} text={whiteIndicator.text} icon={<WhiteArrow width={whiteIndicator.legendSize} height={whiteIndicator.legendSize} color={color} />} />}
      {blackIndicator &&
        <Legend size={blackIndicator.legendSize} text={blackIndicator.text} icon={<BlackArrow width={blackIndicator.legendSize} height={blackIndicator.legendSize} dotColor={dotColor} color={color} />} />}
    </div>
  );
};

const Legend = ({ size, icon, text }) => { 
  return <div className="percentage-circle__legend"><svg width={size} height={size}>{ icon }</svg> = {text}</div>
}

export default PercentageCircle;
